"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedTemplateDefinition1Schema = void 0;
exports.FeedTemplateDefinition1Schema = {
    "$id": "https://www.redbull.com/schemas/system/ext/feed-template-definition/1.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "FeedTemplateDefinition1",
    "description": "Definition for feeds",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:system:ext:feed-template-definition:1"
            ]
        },
        "attributes": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
                "feedComposition": {
                    "type": "array",
                    "items": {
                        "oneOf": [
                            {
                                "type": "object",
                                "additionalProperties": false,
                                "properties": {
                                    "enableInheritanceEnglishInternational": {
                                        "type": "boolean",
                                        "description": "Enable inheritance of assets from featuring records of en-INT locale.",
                                        "default": false
                                    },
                                    "enableInheritanceLocaleMixing": {
                                        "type": "boolean",
                                        "description": "Enable inheritance of assets from featuring records of locale mixing strategy.",
                                        "default": true
                                    },
                                    "featurableContentFilter": {
                                        "type": "string",
                                        "description": "Which content should be allowed for featuring."
                                    },
                                    "featuringAppDefaultFilters": {
                                        "type": "string",
                                        "description": "Which filter should be set by default in the Featuring App"
                                    },
                                    "featuringSubType": {
                                        "type": "string",
                                        "description": "Featuring subtype under which the featuring-record are stored. If not set, the identifier should be used."
                                    },
                                    "kind": {
                                        "description": "Manually picked content elements through the Featuring App",
                                        "const": "featured"
                                    },
                                    "maxFeaturableResources": {
                                        "type": "integer",
                                        "description": "Maximum number of resoruces that can be featured through the Featuring App.",
                                        "minimum": 0
                                    },
                                    "minFeaturableResources": {
                                        "type": "integer",
                                        "description": "Minimum number of resources that need to be featured for this feed. E.g. for manually selected lists at least one element should be selected.",
                                        "minimum": 0
                                    },
                                    "name": {
                                        "type": "string",
                                        "description": "Human readable description of the sub-feed"
                                    }
                                },
                                "required": [
                                    "kind",
                                    "name"
                                ]
                            },
                            {
                                "type": "object",
                                "additionalProperties": false,
                                "properties": {
                                    "kind": {
                                        "description": "Automatically fetched content through the feed-api.",
                                        "const": "query"
                                    },
                                    "name": {
                                        "type": "string",
                                        "description": "Human readable description what the query retrieves"
                                    },
                                    "queries": {
                                        "type": "array",
                                        "description": "One or more queries which are used to fetch content from the feed-api.",
                                        "items": {
                                            "type": "object",
                                            "additionalProperties": false,
                                            "properties": {
                                                "query": {
                                                    "type": "string",
                                                    "description": "The query-string used for fetching results"
                                                }
                                            },
                                            "required": [
                                                "query"
                                            ]
                                        },
                                        "minItems": 1
                                    },
                                    "shuffle": {
                                        "type": "boolean",
                                        "description": "If set to true, results from queries will be shuffeled"
                                    }
                                },
                                "required": [
                                    "name",
                                    "kind",
                                    "queries"
                                ]
                            }
                        ]
                    },
                    "minItems": 1
                }
            },
            "required": [
                "feedComposition"
            ]
        }
    },
    "required": [
        "attributes",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,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